import { useContext } from "react";
import { AppContext } from "../App";
import logo from "../assets/logo.png";
import {
  MdClose,
  MdGroups,
  MdHome,
  MdInfoOutline,
  MdOutlineContactPhone,
  MdOutlineSecurity,
} from "react-icons/md";
import Backdrop from "./Backdrop";

export default function SideBar() {
  const appContext = useContext(AppContext);

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item, subItem = null) {
    appContext.navTo({
      item,
      subItem,
    });

    closeSideBar();
  }

  function isActive(item, subItem = null) {
    if (item === "home") {
      return !appContext.navItem || appContext.navItem === "home";
    }

    if (subItem) {
      return appContext.navItem === item && appContext.navSubItem === subItem;
    }

    return appContext.navItem === item;
  }

  return (
    <>
      <Backdrop
        style={{
          visibility: appContext.isSideBarOpen ? "visible" : "hidden",
          opacity: appContext.isSideBarOpen ? "1" : "0",
          zIndex: "9999",
          pointerEvents: appContext.isSideBarOpen ? "auto" : "none",
        }}
      />

      <aside className="SideBar mShadow2" data-open={appContext.isSideBarOpen}>
        <div className="body mNoScrollBar">
          <div className="sidebar-header">
            <div className="sidebar-brand" onClick={() => goTo("home")}>
              <img src={logo} alt="Runzewe Security" />
              <div>
                <strong>Runzewe Security</strong>
                <span>Tanzania</span>
              </div>
            </div>

            <button className="sidebar-close" onClick={closeSideBar}>
              <MdClose />
            </button>
          </div>

          <button className="sidebar-link" data-active={isActive("home")} onClick={() => goTo("home")}>
            <MdHome />
            <span>Home</span>
          </button>

          <button
            className="sidebar-link"
            data-active={isActive("about")}
            onClick={() => goTo("about", "overview")}
          >
            <MdInfoOutline />
            <span>About</span>
          </button>

          <div className="sidebar-submenu">
            <button
              data-active={isActive("about", "overview") || (appContext.navItem === "about" && !appContext.navSubItem)}
              onClick={() => goTo("about", "overview")}
            >
              Overview
            </button>
            <button data-active={isActive("about", "team")} onClick={() => goTo("about", "team")}>
              Team
            </button>
          </div>

          <button
            className="sidebar-link"
            data-active={isActive("services")}
            onClick={() => goTo("services")}
          >
            <MdOutlineSecurity />
            <span>Services</span>
          </button>

          <button
            className="sidebar-link"
            data-active={isActive("clients")}
            onClick={() => goTo("clients")}
          >
            <MdGroups />
            <span>Clients</span>
          </button>

          <button
            className="sidebar-link"
            data-active={isActive("contact")}
            onClick={() => goTo("contact")}
          >
            <MdOutlineContactPhone />
            <span>Contact</span>
          </button>
        </div>
      </aside>
    </>
  );
}

